"use client";

import SharedIconRail, {
  type IconRailProps as SharedIconRailProps,
} from "@workspace/gamja-platform/components/icon-rail";
import { SettingsButton } from "@/components/settings/SettingsProvider";
import { AuthSection } from "@/components/Menu";
import NotificationBell from "@/components/notifications/NotificationBell";
import SeasonalImage from "@/components/SeasonalImage";
import { NAV_SECTIONS, isSectionActive } from "@/lib/nav-sections";
import {
  usePassSalesClosingSoon,
  withTimedNavBadge,
} from "@/lib/nav-timed-badges";
import {
  MY_DASHBOARD_HOME,
  MY_DASHBOARD_HOME_ICON,
  MY_DASHBOARD_HOME_LABEL,
  MY_DASHBOARD_TITLE,
  MY_NAV_ITEMS,
  isMyNavItemActive,
} from "@/app/my/my-nav";

export type {
  IconRailMyMenu,
  IconRailMyMenuItem,
} from "@workspace/gamja-platform/components/icon-rail";

type JcgIconRailProps = Partial<Omit<SharedIconRailProps, "isSectionActive">>;

/**
 * JCG 전용 어댑터.
 *
 * 레일의 DOM·호버 드로어·플라이아웃은 공용 패키지가 소유하고,
 * 여기서는 JCG의 내비 데이터(섹션·내 메뉴)와 인증 UI, 판매 시즌 뱃지만 주입한다.
 * 기존 호출부는 `<IconRail />` 그대로 쓸 수 있다.
 */
export default function IconRail(props: JcgIconRailProps = {}) {
  const passSalesClosingSoon = usePassSalesClosingSoon();

  return (
    <SharedIconRail
      sections={NAV_SECTIONS}
      isSectionActive={isSectionActive}
      myMenu={{
        title: MY_DASHBOARD_TITLE,
        homeHref: MY_DASHBOARD_HOME,
        homeLabel: MY_DASHBOARD_HOME_LABEL,
        homeIcon: MY_DASHBOARD_HOME_ICON,
        items: MY_NAV_ITEMS,
        isItemActive: isMyNavItemActive,
      }}
      authSection={
        <AuthSection iconClassName="h-5 w-5" showCustomMenuItems={false} />
      }
      // 답글 알림 벨 (JCG-3601) — 비로그인이면 컴포넌트가 스스로 null 을 반환한다
      notifications={<NotificationBell variant="rail" />}
      settingsControl={(expanded) => <SettingsButton showLabel={expanded} />}
      logo={
        <SeasonalImage
          src="/logo.webp"
          alt="정처기 감자"
          width={68}
          height={68}
          className="h-8 w-8 rounded-full object-contain"
        />
      }
      decorateSubLink={(item) => withTimedNavBadge(item, passSalesClosingSoon)}
      {...props}
    />
  );
}
